<div class="flex flex-col h-full">
    <div class="sticky top-0 z-50 bg-white py-4 px-4 md:px-6 lg:px-10 xl:px-20 border-b border-[#dddddd] flex justify-between items-center">
        <div class="text-[#222222] text-xl font-bold">{{ ticket.title }}</div>
        <div class="flex justify-end items-center gap-2">
            <!--<button class="w-full lg:w-auto" mat-stroked-button>
                {{ "Delete Ticket" | transloco }}
            </button>
            <button class="w-full lg:w-auto bg-[#F10051]" color="primary" mat-flat-button>
                {{ "Mark as Resolved" | transloco }}
            </button>-->
        </div>
    </div>

    <!-- Área de conversación -->
    <div class="flex-1 overflow-y-auto py-8 px-4 md:px-6 lg:px-10 xl:px-20">
        <div class="flex flex-col gap-4">
            <div *ngFor="let message of ticket.messages">
                <ng-container *ngIf="(message.user_role !== 'super-admin' && message.user_role !== null) || 
                                    (message.user_role === null && currentUserRole === 'super-admin'); else supportMessage">
                    <div class="w-full flex flex-col items-end gap-1.5">
                        <div class="w-auto max-w-128 text-[#5e5e5e] text-sm font-normal">
                            {{ 'tickets.you' | transloco }} • {{ message.created_at | date:'MMM dd, yyyy' }}
                        </div>
                        <div class="w-auto max-w-128 px-3 py-4 bg-gray-900 rounded-xl flex flex-col items-end">
                            <div class="text-white text-base font-normal text-right">
                                {{ message.content }}
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #supportMessage>
                    <div class="w-full flex flex-col items-start gap-1.5">
                        <div class="w-auto max-w-128 text-[#5e5e5e] text-sm font-normal">
                            {{ 'tickets.customer_support' | transloco }} • {{ message.created_at | date:'MMM dd, yyyy' }}
                        </div>
                        <div class="w-auto max-w-128 px-3 py-4 bg-[#ebebeb] rounded-xl flex flex-col items-start">
                            <div class="text-[#222222] text-base font-normal text-left">
                                {{ message.content }}
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>

            <div *ngIf="!hasSupportMessages" class="p-4 bg-blue-100 text-blue-800 rounded-lg mb-4">
                {{ 'tickets.wait_patient' | transloco }}
            </div>
        </div>
    </div>



    <!-- Área de nuevo mensaje -->
    <div class="sticky bottom-0 z-50 bg-white py-4 px-4 md:px-6 lg:px-10 xl:px-20 inline-flex justify-items-center gap-2 items-center">
        <input
            (keydown.enter)="sendMessage()"
            [(ngModel)]="newMessage"
            class="w-full rounded-full shadow-[0px_4px_4px_0px_rgba(0,0,0,0.04)] border border-[#dddddd] px-5 py-3 focus:outline-none focus:ring-1 focus:ring-neutral-300"
            [placeholder]="'tickets.write_message' | transloco"
            type="text"
        />
        <div (click)="sendMessage()"
             class="w-10 h-10 p-2.5 pl-3 bg-[#f10051] rounded-3xl justify-center items-center inline-flex"
        >
            <mat-icon class="icon-size-5 text-white" svgIcon="heroicons_solid:paper-airplane"></mat-icon>
        </div>
    </div>
</div>